import { API_BASE_URL } from "../config";
import type { Ec2RawInstance } from "../types";

export async function fetchEc2Instances(lookup: string): Promise<Ec2RawInstance[]> {
  const url = `${API_BASE_URL}/ec2/${encodeURIComponent(lookup)}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`EC2 lookup failed for '${lookup}': ${response.status}`);
  }
  return response.json();
}
